//redirection to azure login page
export const redirectToLogin = () => {
    window.location.assign('/sso/api/v1/login');
};

//redirection to specific apps
export const redirectToApp = (appName: string, userId: string, authToken: string) => {
    window.location.assign(`/sso/api/v1/appLogin?user=${userId}&appName=${appName}`);
};

//redirection to login
export const redirectToSSOLogin = () => {
    const currentLocation = `${window.location}`
    const regex = /\?appName=([^#]*)$/;
    const match = currentLocation.match(regex);
    const matchedSource = match ? match[1].trim() : "";
    window.location.assign(`/sso/auth/login?source=${matchedSource}&postRedirectURI=${currentLocation}`);
};


export const isNullOrUndefined = (value: any) => value === null || value === undefined;

//env select
export const getEnvType = (hostname: string): 'QA' | 'UAT' | 'DEV' | '' => {
    if (hostname.includes('dev')) {
        return 'DEV';
    }else if (hostname.includes('qa')) {
        return 'QA';
    }else if (hostname.includes('uat')) {
        return 'UAT';
    }
    return '';
};

//about model cancel btn
export const CancelAboutModel = (e: any, props: { isVisibleAbout: boolean; setIsVisibleAbout: Function }) => {
    if (props.isVisibleAbout === true) {
        props.setIsVisibleAbout(false);
    }
};

//dynamic year
export const CurrentYear = new Date().getFullYear();

//get url from browser
export const current_url = window.location.href;

//redirect to logout
export const redirectToLogOut = () => {
    window.location.assign(
        `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${current_url}`
    );
};

// help section toggle
export const HelpDropdown = (props: {
    isHelpClicked: boolean;
    setIsHelpClicked: Function;
    setShowClassAdd: Function;
}) => {
    if (props.isHelpClicked === false) {
        props.setIsHelpClicked(true);
        props.setShowClassAdd('show');
    } else {
        props.setIsHelpClicked(false);
        props.setShowClassAdd('');
    }
};

//show and hide about
export const showAboutModel = (props: { isVisibleAbout: boolean; setIsVisibleAbout: Function }) => {
    if (props.isVisibleAbout === false) {
        props.setIsVisibleAbout(true);
    }
};

//get the page cookie
export function checkCookie(cookieName: string): string {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith(cookieName + '=')) {
            return trimmedCookie.split('=')[1];
        }
    }
    return '';
}

export const getLoginUrl = (environment: string) => {
    switch (environment.toUpperCase()) {
        case 'DEV':
            return "https://dev.sso.osttra.com/";
        case 'QA':
          return "https://test.sso.osttra.com/";
        default:
          return "https://sso.osttra.com/";
    }
};
